import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'I played Audio 3 four times in one week. It was the only thing that stopped the 2am spiral.',
  author: 'New mom, 8 weeks postpartum',
  image: 'https://images.unsplash.com/photo-1555252333-9f8e92e65df9?q=80&w=150&auto=format&fit=crop'
}, {
  quote: "I didn't think I was someone who listened to guided audios. Then I tried The Transfer Breath before the nap attempt and my hands actually stopped shaking.",
  author: 'First-time mom, 10 weeks postpartum',
  image: 'https://images.unsplash.com/photo-1519689680058-324335c77eba?q=80&w=150&auto=format&fit=crop'
}];
export function SocialProofSection() {
  return <section className="py-16 px-6 relative overflow-hidden" data-id="element-182">
      <div className="max-w-md mx-auto flex flex-col gap-6 relative z-10" data-id="element-183">
        {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: index * 0.2
      }} className="bg-white/40 backdrop-blur-md rounded-2xl p-6 shadow-[0_8px_30px_rgba(201,166,107,0.15),inset_0_1px_0_rgba(255,255,255,0.8)] border border-white/60 relative" data-id="element-184">
            <div className="absolute -top-4 -left-2 text-6xl font-playfair text-copper/20 select-none pointer-events-none" data-id="element-185">
              "
            </div>
            <p className="font-playfair italic text-charcoal text-lg leading-relaxed opacity-90 mb-6 relative z-10" data-id="element-186">
              {testimonial.quote}
            </p>
            <div className="flex items-center gap-3 relative z-10" data-id="element-187">
              <img src={testimonial.image} alt="Mother" className="w-10 h-10 rounded-full object-cover border border-copper/20 shadow-sm" data-id="element-188" />
              <p className="font-inter text-copper text-xs font-semibold tracking-wider uppercase leading-snug" data-id="element-189">
                {testimonial.author}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}